import { render, staticRenderFns } from "./ReportesBajasTransitoBtnActions.vue?vue&type=template&id=1bb448fc&"
import script from "./ReportesBajasTransitoBtnActions.vue?vue&type=script&lang=ts&"
export * from "./ReportesBajasTransitoBtnActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1bb448fc', component.options)
    } else {
      api.reload('1bb448fc', component.options)
    }
    module.hot.accept("./ReportesBajasTransitoBtnActions.vue?vue&type=template&id=1bb448fc&", function () {
      api.rerender('1bb448fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ReportesBajasTransito/ReportesBajasTransitoBtnActions.vue"
export default component.exports